export default class EmbeddedTimeEntriesDashboardService {
  constructor(leanLawAuth, http) {
    this.leanLawAuth = leanLawAuth;
    this.http = http;
  }
  async getEmbeddedTimeEntriesDashboard() {
    return 'reportstime';
  }
  get domain() {
    return this.leanLawAuth.domain;
  }
}